import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

import { BorderRadius } from '../../enums/borderRadius'
import { Color } from '../../enums/color'
import { Spacing } from '../../enums/spacing'

interface TabButtonsGroupWrapperProps {
  fullWidth?: boolean
}

export const TabButtonsGroupWrapper = styled.div<TabButtonsGroupWrapperProps>`
  display: inline-flex;
  gap: ${Spacing.S2};
  padding: ${Spacing.S4};
  border-radius: ${BorderRadius.R12};
  background-color: ${transparentize(0.6, Color.Grey200)};

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}
`
